module.exports = __webpack_public_path__ + "6d19ef07716b078248f0c79e6220bb08.svg";